import React from 'react';
import styles from '../ReportCard.module.scss';

const CameraIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </svg>
);

/**
 * Кнопка "Сканировать QR" с запросом разрешения камеры.
 *
 * @param {Object} props
 * @param {string}  props.label   — текст кнопки ("Сканировать QR" / "Сканировать")
 * @param {boolean} props.success — показывать "✅ Подтверждено"?
 * @param {Function} props.onScan — колбэк при нажатии (после получения разрешения)
 * @param {Function} props.onNotify
 */
const ScanButton = ({ label = 'Сканировать', success, onScan, onNotify }) => {
  const handleClick = async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        // Запрашиваем заднюю камеру { exact } чтобы браузер сразу открыл нужную
        let stream = null;
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: { exact: 'environment' } },
          });
        } catch (_) {
          // Fallback: ideal mode
          try {
            stream = await navigator.mediaDevices.getUserMedia({
              video: { facingMode: { ideal: 'environment' } },
            });
          } catch (_2) {
            stream = await navigator.mediaDevices.getUserMedia({ video: true });
          }
        }
        // Сразу останавливаем предварительный поток — useCamera сам стартует нужную
        if (stream) stream.getTracks().forEach(t => t.stop());
        onScan();
      } catch (err) {
        onNotify({
          isOpen: true,
          message: 'Разрешите доступ к камере для сканирования QR-кода!',
          type: 'error',
        });
      }
    } else {
      onNotify({
        isOpen: true,
        message: 'Ваше устройство не поддерживает доступ к камере!',
        type: 'error',
      });
    }
  };

  return (
    <>
      <button onClick={handleClick} className={styles.btn_tabel}>
        <CameraIcon /> {label}
      </button>
      {success && (
        <div style={{ color: 'green', fontWeight: 'bold', marginTop: 10, fontSize: 16 }}>
          ✅ Подтверждено
        </div>
      )}
    </>
  );
};

export default React.memo(ScanButton);
